// extracted by mini-css-extract-plugin
export default {"Chat":"styles_Chat__HpSUi"};